import { getApiCall} from '../service/httpCall';
import { API_LIST_EXPORT } from '../service/url';
import { toast } from "react-toastify";



function getApiUrl(url, model) {
  return url.replace(":model", model);
}

const exportData = async (model) => {
    try {
      const exportApiUrl = getApiUrl(API_LIST_EXPORT, model);
      const response = await getApiCall(exportApiUrl, {});
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${model}.csv`);
      document.body.appendChild(link);
      link.click();
      toast.success(`${model} data exported successfully`);
    } catch (err) {
      toast.error("Error in exporting data");
      console.error(`Error exporting ${model} data:`, err);
    }
  };

export default exportData;
